import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import classNames from 'classnames'
import { StrippedVendor } from '../../redux-toolkits/vendors/vendors.types'
import Icon from '../icon'

export const HPCreator = ({
  creator,
  id,
  sortable = false,
  className = '',
  onRemove,
}: {
  creator: StrippedVendor
  id: string
  sortable?: boolean
  className?: string
  onRemove?: () => void
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      className={classNames(
        'relative w-full flex flex-col bg-frost',
        className,
      )}
      ref={setNodeRef}
      style={style}
    >
      <div className="relative">
        <img
          src={creator?.banner}
          className="block w-full aspect-square max-h-[140px] object-cover rounded-md"
          alt={`banner`}
        />

        <img
          src={creator.logo}
          className="block w-[48px] left-4 -bottom-6 h-[48px] rounded-full shadow-lg aspect-square object-cover bg-white absolute"
          alt={`logo`}
        />
      </div>

      <p className="line-clamp-1 mt-10 text-black text-base font-medium">
        {creator?.name}
      </p>

      <p className="line-clamp-2 mt-2 text-sec-black text-sm">
        {creator?.extendedBio ?? 'No Bio'}
      </p>

      {id && sortable ? (
        <div className="flex w-full items-end justify-center flex-1">
          <button
            className="w-fit cursor-grab mx-auto mt-4 !max-w-[50px]"
            {...attributes}
            {...listeners}
            type="button"
          >
            <Icon id="rearrange" width={24} height={24} />
          </button>
        </div>
      ) : undefined}

      {onRemove && (
        <button
          className={classNames(
            'p-2 bg-gray-bg rounded-full w-fit absolute top-4 right-4',
          )}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <Icon className="text-danger" width={20} height={20} id="bin" />
        </button>
      )}
    </div>
  )
}
